import React from "react";
import styles from "../assets/css/Validation.module.css";

export default function DetalleModal({ solicitud, onClose }) {
  if (!solicitud) return null;

  return (
    <div className={styles.overlay} onClick={onClose}>
      <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
        <h3>Detalle de la solicitud</h3>
        <p><strong>ID:</strong> {solicitud.id}</p>
        <p><strong>Tipo:</strong> {solicitud.tipo}</p>
        <p><strong>Estado:</strong> {solicitud.estado}</p>
        <p><strong>Fecha:</strong> {solicitud.fecha}</p>
        <p><strong>Detalle:</strong> {solicitud.detalle}</p>
        <button className={styles.closeBtn} onClick={onClose}>
          Cerrar
        </button>
      </div>
    </div>
  );
}
